export enum ItemType {
  Pistol = "pistol",
  Shotgun = "shotgun",
  SMG = "smg",
  Rifle = "rifle",
  Sniper = "sniper",
  Heavy = "heavy",
  Melee = "melee",
  MachineGuns = "machine_guns",

  Ammo = "ammo",

  Muffler = "muffler",
  Clip = "clip",
  Grip = "grip",
  Scope = "scope",
  Flashlight = "flashlight",
  Muzzle = "muzzle",

  Hat = "hat",
  Glasses = "glasses",
  Watches = "watches",
  Ears = "ears",
  Bracelets = "bracelets",
  MedicineChest = "medicine_chest",

  Mask = "mask",
  Legs = "legs",
  Tops = "tops",
  Shoes = "shoes",
  Burger = "burger",
  Bag = "bag",
  Armor = "armor",

  Canister = "canister",
  Bottle = "bottle",

  Unknown = "unknown",
}
